import React, { useReducer, useContext, createContext } from "react";

const initialState = {
  brands: [],
  ranges: [],
  models: [],
  year: "",
  mmCode: "",
};

export const ACTIONS = {
  SET_BRANDS: "SET_BRANDS",
  SET_RANGES: "SET_RANGES",
  SET_MODELS: "SET_MODELS",
  SET_YEAR: "SET_YEAR",
  SET_MMCODE: "SET_MMCODE",
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_BRANDS:
      return {
        ...state,
        brands: action.payload,
      };
    case ACTIONS.SET_RANGES:
      return {
        ...state,
        ranges: action.payload,
      };
    case ACTIONS.SET_MODELS:
      return {
        ...state,
        models: action.payload,
      };
    case ACTIONS.SET_YEAR:
      return {
        ...state,
        year: action.payload,
      };
    case ACTIONS.SET_MMCODE:
      return {
        ...state,
        mmCode: action.payload,
      };
    default:
      return state;
  }
};

const MatchToCarContext = createContext(initialState);

export default function MatchToCarProvider({ children }) {
  return (
    <MatchToCarContext.Provider value={useReducer(reducer, initialState)}>
      {children}
    </MatchToCarContext.Provider>
  );
}

export const useMatchToCarContext = () => useContext(MatchToCarContext);
